<template lang="pug"> 
  v-card(flat tile)
    v-app-bar.overlay.no-padding(
      dense
      flat
      fixed
      extension-height='30'
    )
      v-btn(
        dark
        outlined
        small
        fab
        @click='!isMobile ? expandNav() : $refs.sidebarRef.openSideBar()'
      ) {{ isMobile ? $t('menu') : expandStatus ? $t('expand') : $t('reduce-expand') }} 
      router-link(:to='{ name:ROUTE_INDEX }', @click='GAmainbar(links[0].name )')
        #titlelogo
          h3.ml-2.white--text.font-weight-black
            i.notranslate Huay
            i.light-yellow--text.notranslate Buy
      v-spacer 
      div(v-if='!isHideTopExternalGame')
        v-btn(v-if='!links[1].Isclosed' text :to="{ name:links[1].pathName }" @click='GAmainbar(links[1].name )')
          v-img.mr-2(:src='links[1].imgWhite' max-width="24")
          span.white--text
            b {{ links[1].name }}
        v-btn(v-if='!links[2].Isclosed' text :to="{ name:links[2].pathName }" @click='GAmainbar(links[2].name)')
          v-img.mr-2(:src='links[2].imgWhite' max-width="24")
          span.white--text
            b {{ links[2].name }}
        v-btn(v-if='!links[3].Isclosed' text :to="{ name:links[3].pathName }" @click='GAmainbar(links[3].name)')
          v-img.mr-2(:src='links[3].imgWhite' max-width="24")
          span.white--text
            b {{ links[3].name }}
        v-btn(v-if='!links[4].Isclosed' text :to="{ name:links[4].pathName }" @click='GAmainbar(links[4].name )')
          v-img.mr-2(:src='links[4].imgWhite' max-width="24")
          span.white--text
            b {{ links[4].name }}
        v-btn(v-if='!links[5].Isclosed' text :to="{ name:links[5].pathName }" @click='GAmainbar(links[5].name )')
          v-img.mr-2(:src='links[5].imgWhite' max-width="24")
          span.white--text
            b {{ links[5].name }}
      v-spacer
      v-btn(text x-small dark :to='{ name:ROUTE_DEPOSIT }' v-if='!isMobile')
        v-icon(small) mdi-plus
        h3 {{ $t('button.deposit') }}
      v-btn(text small @click='refreshCredit()')
        v-img(width='24', :src="require('@/assets/anything/Wallet.svg')")
        span.white--text.mx-1
          h3 {{ wallet.amount }}
        v-icon(v-if='!walletLoading' color="white")  mdi-cached
        v-icon(v-else color="white")  mdi-cached  mdi-spin
      template(v-if='marqueeStatus', #extension)
        div(@mouseenter='marqueePause=true' @mouseleave='marqueePause=false')
          marquee-text(:duration='marqueeSpeed' :paused='marqueePause')
            v-row(align='center')
              v-col
                div(v-html='marqueeText')
    nav-drawer(
      ref="sidebarRef" 
      :expand-status='expandStatus'
      :marquee-status='marqueeStatus'
      :items="links"
    )
    dialog-select-external-game(ref='dialogselectexternalgameref', @loadCredit='creditInit')

</template>
<script> 
import { filterTag } from '@/utils/filterString'   
import {
  news as apiMarquee, 
  service as apiExternal, 
  gameType as apiGameType 
} from '@/apis' 
import { FETCHMARQUEE, FETCHCREDIT } from '@/const/setTimeOutConfig' 
import { ROUTE_INDEX,ROUTE_DEPOSIT } from '@/const/route' 
import { menues } from '@/const/menues'
import NavDrawer from './NavDrawer-v1'   
import dialogSelectExternalGame from '@/components/Dialog/DialogSelectExternalGame'
export default {
  components:{ 
    NavDrawer,  
    dialogSelectExternalGame
  },  

  data: () => ({  
    marqueeText : null,
    marqueeArray : [],
    marqueeStatus : false, 
    marqueePause : false, 
    expandStatus:true, 
    links:menues,
    setTimeoutMarquee: null,
    setTimeoutCredit: null
  }),

  computed : {
    ROUTE_INDEX: () => ROUTE_INDEX,
    ROUTE_DEPOSIT: () => ROUTE_DEPOSIT,
    isHideTopExternalGame () {
      return !this.$vuetify.breakpoint.lgAndUp 
    },
    isMobile () {
      return !this.$vuetify.breakpoint.mdAndUp
    },
    externalgame () {
      return this.$store.getters['externalGame/GETTERS_EXTERNALGAME']
    },
    isUserActive () {
      return this.$store.getters['appbar/GETTERS_USER_ACTIVE']
    },
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    walletLoading () {
      return this.$store.getters['userProfile/GETTERS_WALLET_STATUS']
    },
    isLogin () {
      return this.$store.getters['auth/GETTERS_TOKEN'] !== null
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    marqueeSpeed () { 
      return Math.round(this.marqueeText.length/10)
    },

    accessToken () {
      return this.$route.query.token
    },
    isTabActive () {
      return this.$store.getters['appbar/GETTERS_TAB_ACTIVE']
    },
  }, 

  watch: {
    // accessToken () {
    //   this.checkBoAccessToken() 
    // }, 
    marqueeArray () {
      this.marqueeStatus = true
      setTimeout(()=>{
        this.marqueeStatus = false
      },120000) 
    },
  }, 

  async created () {
    if(this.isLogin){   
      await this.$store.dispatch('userProfile/ACTION_ME',true)
      await this.externalGameInit ()  
      await this.checkCurrentGame ()
      await this.fetchMarquee ()
      await this.creditInit()  
      // this.checkBoAccessToken()
      // setInterval(()=>{this.fetchMarquee()},FETCHMARQUEE)
      // setInterval(()=>{this.creditInit()},FETCHCREDIT)
    }

    this.setTimeoutMarquee = this.reloadMarquee()
    this.setTimeoutCredit = this.reloadCredit()
    
    window.addEventListener("storage", this.handleEventStore);
    window.addEventListener('blur', this.handleEventBlur);
    window.addEventListener('focus', this.handleEventFocus);
  }, 

  beforeDestroy () {
    // return source to processor
    clearTimeout(this.setTimeoutMarquee)
    clearTimeout(this.setTimeoutCredit)

    window.removeEventListener("storage", this.handleEventStore);
    window.removeEventListener('blur', this.handleEventBlur);
    window.removeEventListener('focus', this.handleEventFocus);
  },

  methods:{
    handleEventStore (e) {
      //update storage to check in state
      const idLastActiveTab = e.storageArea['idLastActiveTab']

      const isTabActve = this.idTab === idLastActiveTab
      this.$store.commit('appbar/MUTATION_TAB_ACTIVE', isTabActve)
    },
    handleEventBlur () {
      this.$store.commit('appbar/MUTATION_USER_ACTIVE',false)
      this.$store.dispatch('appbar/ACTION_USER_ACTIVE')
    },
    handleEventFocus () {
      this.$store.commit('appbar/MUTATION_USER_ACTIVE',true)
      this.$store.commit('appbar/MUTATION_TAB_ACTIVE', true)
      this.$store.dispatch('appbar/ACTION_USER_ACTIVE')
      this.checkCurrentGame() 
    },
    // checkBoAccessToken () { 
    //   if(this.accessToken) {
    //     localStorage.setItem('access-Token',this.accessToken) 
    //     this.$router.push({
    //       name:ROUTE_INDEX
    //     })
    //     window.location.reload()
    //   }
    // },
    reloadCredit () {
      setTimeout(()=> {
        this.creditInit ()
        this.reloadCredit()
      },FETCHCREDIT)

    },

    reloadMarquee () {
      setTimeout(()=> {
        this.fetchMarquee ()
        this.reloadMarquee()
      },FETCHMARQUEE)
    },

    async creditInit () {
      if(this.isLogin && this.isTabActive){
        this.$store.dispatch('userProfile/ACTION_WALLET')
      }
    }, 
    
    async fetchMarquee () {
      if(this.isLogin && this.isTabActive){
        let reset = false 
        let type = { type:4 }
        const [err,data ] =  await apiMarquee.getNews(type)

        if(err) {
          this.$alert('',err,'warning') 
          return
        }
        
        if(data.length!==0) { 
          data.forEach(e=>{ 
            if(this.marqueeArray.find(x=>x.uuid===e.uuid)){
              e.count ? e.count+=1 : e.count = 0   
            } else {
              e.count = 0
              this.marqueeStatus = false
              this.marqueeArray.push(e)  
              reset = true 
            }
          }) 
        }

        if(reset) {  
          this.marqueeText = Array(Math.round(window.innerWidth/4)).fill('\xa0').join('') 
          this.marqueeArray.forEach(e=>{ 
            if(!e.count || e.count<=2 ){     
              this.marqueeText += `${e.title} : ${filterTag(e.description)} ${Array(Math.round(window.innerWidth/8)).fill('\xa0').join('')} `  
            } 
          })  
        }
      }
    },

    checkClosePersonalExternalGame () {
      if(this.externalgame.find(x=>x.category_game_type_id===2)){
        this.links[2].Isclosed = false
      }
      if(this.externalgame.find(x=>x.category_game_type_id===3)){
        this.links[3].Isclosed = false
      }
      if(this.externalgame.find(x=>x.category_game_type_id===4)){
        this.links[4].Isclosed = false
      }
      if(this.externalgame.find(x=>x.category_game_type_id===5)){ 
        this.links[5].Isclosed = false
      }
      // //check for coach list item
      // if((this.userProfile || {}).coach){
      //    this.links[16].Isclosed = false 
      //    this.links[16].to = `${(this.userProfile.coach || {}).link}`
      // }
      //fetch for component not update in file not yet
      this.$forceUpdate()
    },

    async checkCurrentGame () {
      if(this.isLogin) {  
        const [err,data ] =  await apiExternal.getCurrentGame()
         
        if(err) {
          this.$alert('',err,'warning') 
          return
        }   
        if(data.length !== 0 ) {  
          this.$refs.dialogselectexternalgameref.openDialog(data) 
        } 
      }
    },

    async externalGameInit (params = {}) {
      params.scope = 'external'
      const [err,data ] = await apiGameType.get(params)
      
      if(err ) {
        return
      }
      // || !this.userProfile.games_closed
      // this.userProfile.games_closed.forEach(element => {  
      //   let index = data.findIndex(x=>x.id===element.id) 
      //   if(index >=0 ) {
      //     data.splice(index,1)
      //   }
      // }); 
      
      this.$store.commit('externalGame/MUTATION_EXTERNALGAME',data)
      this.checkClosePersonalExternalGame()
    },

    expandNav () {    
      this.$ga.event('Button', 'ExpandSidebar', 'SideBar','' ) 
      this.expandStatus=!this.expandStatus  
    },

    GAmainbar (name){
      this.$ga.event('Button', 'SelectPage', 'MainBar',name )
    },

    refreshCredit (){ 
      this.$ga.event('Button', 'RefreshWallet', 'MainBar','' ) 
      this.creditInit()
      this.checkCurrentGame()
    },
  }
} 
</script>
<style scoped> 
#titlelogo {
  font-family: CooperHewitt !important;
  font-style: normal;
  margin: 0;  
  transition: 200ms all;
  font-size: calc(1rem + 0.25vh);
} 
.overlay { 
  z-index: 80!important;  
  background-color:var(--bg-main-color) !important;
}    
.no-padding >>> .v-toolbar__extension {
  padding: 0px !important;
  background-color: yellow; 
}
</style>
